export default {
  PDF: "application/pdf",
  PNG: "image/png",
  JPEG: "image/jpeg",
  TIFF: "image/tiff",
  GIF: "image/gif"
};
